import { NgModule } from '@angular/core';
import { GeneralHeaderTitleComponent } from './general-header-title.component';
import { SharedModule } from '../shared';
import { SponsorHeaderTitleComponent } from './sponsor-header-title.component';
import { InvestigatorHeaderTitleComponent } from './investigator-header-title.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        GeneralHeaderTitleComponent,
        SponsorHeaderTitleComponent,
        InvestigatorHeaderTitleComponent
    ],
    exports: [
        GeneralHeaderTitleComponent,
        SponsorHeaderTitleComponent,
        InvestigatorHeaderTitleComponent
    ]
})
export class HeaderTitleModule { }